import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { Navigation } from '@shopify/polaris';
import { InventoryIcon } from '@shopify/polaris-icons';
import { AuthenticationContext } from '../../../homeModules/auth/contexts/AuthenticationContext';

const EmployeePortalSidebar = () => {
  const location = useLocation();
  const { user } = useContext(AuthenticationContext);
  const hasAdminModule = user?.modules?.some((module) => module.value === 'employee_portal' && parseInt(module.tier) > 2);

  const subNavigationItems = [{ url: '/employee_portal/warehouse_pickup', disabled: false, label: 'Warehouse Pickup' }];

  const navigationItems = [
    {
      label: 'Employee Portal',
      url: '/employee_portal/warehouse_pickup',
      icon: InventoryIcon as any,
      matches: true,
      subNavigationItems,
    },
  ];

  return (
    <Navigation location={location.pathname}>
      <Navigation.Section items={navigationItems} />
    </Navigation>
  );
};

export default EmployeePortalSidebar;
